import type { ToolResult } from "~/helpers/aiChat/chatStorage";
import type { ToolCallResult } from "~/services/aiOrchestrator";

import summarizeToolResult from "~/helpers/aiChat/summarizeToolResult";

const buildToolResults = (toolCalls: ToolCallResult[]): ToolResult[] => {
	const byTool = new Map<string, ToolResult>();
	for (const call of toolCalls) {
		const { detail, summary } = summarizeToolResult(call.result, { commit: call.status === "ERROR" });
		byTool.set(call.toolName, { detail, status: call.status, summary, toolName: call.toolName });
	}
	return [...byTool.values()];
};

export default buildToolResults;
